export default "__VITE_ASSET__BUBwzOyM__"